var render = function () {
  var _vm$milestoneInfo, _vm$milestoneInfo2, _vm$milestoneInfo3, _vm$milestoneInfo4, _vm$milestoneInfo5, _vm$milestoneInfo6, _vm$milestoneInfo7, _vm$milestoneInfo7$pr, _vm$milestoneInfo7$pr2, _vm$milestoneInfo7$pr3, _vm$milestoneInfo7$pr4, _vm$milestoneInfo8, _vm$milestoneInfo8$pr, _vm$milestoneInfo8$pr2, _vm$milestoneInfo8$pr3, _vm$milestoneInfo8$pr4, _vm$milestoneInfo9, _vm$milestoneInfo9$pr, _vm$milestoneInfo9$pr2, _vm$milestoneInfo9$pr3, _vm$milestoneInfo9$pr4, _vm$milestoneInfo10, _vm$milestoneInfo10$p, _vm$milestoneInfo10$p2, _vm$milestoneInfo10$p3, _vm$milestoneInfo10$p4, _vm$milestoneInfo11, _vm$milestoneInfo11$p, _vm$milestoneInfo11$p2, _vm$milestoneInfo11$p3, _vm$milestoneInfo11$p4, _vm$milestoneInfo12, _vm$accountInfo, _vm$accountInfo2, _vm$accountInfo3, _vm$accountInfo4, _vm$accountInfo5, _vm$accountInfo5$coun, _vm$accountInfo5$coun2, _vm$accountInfo6, _vm$accountInfo7, _vm$accountInfo8, _vm$accountInfo9, _vm$milestoneInfo14, _vm$milestoneInfo15, _vm$milestoneInfo16, _vm$milestoneInfo17, _vm$milestoneInfo18, _vm$milestoneInfo19, _vm$milestoneInfo20, _vm$milestoneInfo21, _vm$milestoneInfo22, _vm$milestoneInfo23, _vm$milestoneInfo24, _vm$milestoneInfo25, _vm$milestoneInfo25$p, _vm$milestoneInfo25$p2, _vm$milestoneInfo25$p3, _vm$milestoneInfo25$p4, _vm$milestoneInfo26, _vm$milestoneInfo26$p, _vm$milestoneInfo26$p2, _vm$milestoneInfo26$p3, _vm$milestoneInfo26$p4, _vm$milestoneInfo27, _vm$milestoneInfo27$p, _vm$milestoneInfo27$p2, _vm$milestoneInfo27$p3, _vm$milestoneInfo27$p4, _vm$milestoneInfo28, _vm$milestoneInfo28$p, _vm$milestoneInfo28$p2, _vm$milestoneInfo28$p3, _vm$milestoneInfo28$p4, _vm$milestoneInfo29, _vm$milestoneInfo29$p, _vm$milestoneInfo29$p2, _vm$milestoneInfo29$p3, _vm$milestoneInfo29$p4, _vm$milestoneInfo30, _vm$accountInfo10, _vm$accountInfo11, _vm$accountInfo12, _vm$accountInfo13, _vm$accountInfo14, _vm$accountInfo14$cou, _vm$accountInfo14$cou2, _vm$accountInfo15, _vm$accountInfo16, _vm$accountInfo17, _vm$accountInfo18, _vm$milestoneInfo31, _vm$milestoneInfo32, _vm$milestoneInfo33, _vm$milestoneInfo34;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "invoice-preview-wrapper"
  }, [_c('b-row', {
    staticClass: "invoice-preview"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "xl": "9",
      "md": "8"
    }
  }, [_c('b-card', {
    staticClass: "invoice-preview-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "invoice-padding pb-0"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
  }, [_c('div', [_c('div', {
    staticClass: "logo-wrapper"
  }, [_vm.companyLogo ? [_c('img', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "src": _vm.companyLogo,
      "alt": "Company Logo",
      "height": "60"
    }
  })] : [_c('h1', [_vm._v("Logo")])]], 2), _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.officeAddress)
    }
  }), _c('p', {
    staticClass: "card-text mb-0"
  }, [_vm._v("Phone: " + _vm._s(this.officeEmail))]), _c('p', {
    staticClass: "card-text mb-0"
  }, [_vm._v("Email: " + _vm._s(this.officeMobile))])]), _c('div', {
    staticClass: "mt-md-0 mt-2"
  }, [_c('h4', {
    staticClass: "invoice-title"
  }, [_vm._v(" Invoice "), _c('span', {
    staticClass: "invoice-number"
  }, [_vm._v("# " + _vm._s((_vm$milestoneInfo = _vm.milestoneInfo) === null || _vm$milestoneInfo === void 0 ? void 0 : _vm$milestoneInfo.invoice_no))]), ((_vm$milestoneInfo2 = _vm.milestoneInfo) === null || _vm$milestoneInfo2 === void 0 ? void 0 : _vm$milestoneInfo2.status) == 'paid' ? [_c('b-badge', {
    staticClass: "ml-1",
    attrs: {
      "pill": "",
      "variant": "light-success"
    }
  }, [_vm._v("Paid")])] : ((_vm$milestoneInfo3 = _vm.milestoneInfo) === null || _vm$milestoneInfo3 === void 0 ? void 0 : _vm$milestoneInfo3.status) == 'due' ? [_c('b-badge', {
    staticClass: "ml-1",
    attrs: {
      "pill": "",
      "variant": "light-danger"
    }
  }, [_vm._v("Due")])] : ((_vm$milestoneInfo4 = _vm.milestoneInfo) === null || _vm$milestoneInfo4 === void 0 ? void 0 : _vm$milestoneInfo4.status) == 'forward' ? [_c('b-badge', {
    staticClass: "ml-1",
    attrs: {
      "pill": "",
      "variant": "light-warning"
    }
  }, [_vm._v("All Forwarded")])] : _vm._e()], 2), _c('div', {
    staticClass: "invoice-date-wrapper"
  }, [_c('p', {
    staticClass: "invoice-date-title"
  }, [_vm._v("Date Issued:")]), _c('p', {
    staticClass: "invoice-date"
  }, [_vm._v(" " + _vm._s(_vm.formatDeadline((_vm$milestoneInfo5 = _vm.milestoneInfo) === null || _vm$milestoneInfo5 === void 0 ? void 0 : _vm$milestoneInfo5.invoice_created_date)) + " ")])]), _c('div', {
    staticClass: "invoice-date-wrapper"
  }, [_c('p', {
    staticClass: "invoice-date-title"
  }, [_vm._v("Due Date:")]), _c('p', {
    staticClass: "invoice-date"
  }, [_vm._v(" " + _vm._s(_vm.formatDeadline((_vm$milestoneInfo6 = _vm.milestoneInfo) === null || _vm$milestoneInfo6 === void 0 ? void 0 : _vm$milestoneInfo6.date)) + " ")])])])])]), _c('hr', {
    staticClass: "invoice-spacing"
  }), _c('b-card-body', {
    staticClass: "invoice-padding pt-0"
  }, [_c('b-row', {
    staticClass: "invoice-spacing"
  }, [_c('b-col', {
    staticClass: "p-0",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("Invoice To:")]), _c('h6', {
    staticClass: "mb-25"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo7 = _vm.milestoneInfo) === null || _vm$milestoneInfo7 === void 0 ? void 0 : (_vm$milestoneInfo7$pr = _vm$milestoneInfo7.project) === null || _vm$milestoneInfo7$pr === void 0 ? void 0 : (_vm$milestoneInfo7$pr2 = _vm$milestoneInfo7$pr.data) === null || _vm$milestoneInfo7$pr2 === void 0 ? void 0 : (_vm$milestoneInfo7$pr3 = _vm$milestoneInfo7$pr2.lead) === null || _vm$milestoneInfo7$pr3 === void 0 ? void 0 : (_vm$milestoneInfo7$pr4 = _vm$milestoneInfo7$pr3.data) === null || _vm$milestoneInfo7$pr4 === void 0 ? void 0 : _vm$milestoneInfo7$pr4.key_contact_person) + " ")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo8 = _vm.milestoneInfo) === null || _vm$milestoneInfo8 === void 0 ? void 0 : (_vm$milestoneInfo8$pr = _vm$milestoneInfo8.project) === null || _vm$milestoneInfo8$pr === void 0 ? void 0 : (_vm$milestoneInfo8$pr2 = _vm$milestoneInfo8$pr.data) === null || _vm$milestoneInfo8$pr2 === void 0 ? void 0 : (_vm$milestoneInfo8$pr3 = _vm$milestoneInfo8$pr2.lead) === null || _vm$milestoneInfo8$pr3 === void 0 ? void 0 : (_vm$milestoneInfo8$pr4 = _vm$milestoneInfo8$pr3.data) === null || _vm$milestoneInfo8$pr4 === void 0 ? void 0 : _vm$milestoneInfo8$pr4.company_name) + " ")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Address: " + _vm._s((_vm$milestoneInfo9 = _vm.milestoneInfo) === null || _vm$milestoneInfo9 === void 0 ? void 0 : (_vm$milestoneInfo9$pr = _vm$milestoneInfo9.project) === null || _vm$milestoneInfo9$pr === void 0 ? void 0 : (_vm$milestoneInfo9$pr2 = _vm$milestoneInfo9$pr.data) === null || _vm$milestoneInfo9$pr2 === void 0 ? void 0 : (_vm$milestoneInfo9$pr3 = _vm$milestoneInfo9$pr2.lead) === null || _vm$milestoneInfo9$pr3 === void 0 ? void 0 : (_vm$milestoneInfo9$pr4 = _vm$milestoneInfo9$pr3.data) === null || _vm$milestoneInfo9$pr4 === void 0 ? void 0 : _vm$milestoneInfo9$pr4.address) + " ")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Email: " + _vm._s((_vm$milestoneInfo10 = _vm.milestoneInfo) === null || _vm$milestoneInfo10 === void 0 ? void 0 : (_vm$milestoneInfo10$p = _vm$milestoneInfo10.project) === null || _vm$milestoneInfo10$p === void 0 ? void 0 : (_vm$milestoneInfo10$p2 = _vm$milestoneInfo10$p.data) === null || _vm$milestoneInfo10$p2 === void 0 ? void 0 : (_vm$milestoneInfo10$p3 = _vm$milestoneInfo10$p2.lead) === null || _vm$milestoneInfo10$p3 === void 0 ? void 0 : (_vm$milestoneInfo10$p4 = _vm$milestoneInfo10$p3.data) === null || _vm$milestoneInfo10$p4 === void 0 ? void 0 : _vm$milestoneInfo10$p4.email) + " ")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Mobile: " + _vm._s((_vm$milestoneInfo11 = _vm.milestoneInfo) === null || _vm$milestoneInfo11 === void 0 ? void 0 : (_vm$milestoneInfo11$p = _vm$milestoneInfo11.project) === null || _vm$milestoneInfo11$p === void 0 ? void 0 : (_vm$milestoneInfo11$p2 = _vm$milestoneInfo11$p.data) === null || _vm$milestoneInfo11$p2 === void 0 ? void 0 : (_vm$milestoneInfo11$p3 = _vm$milestoneInfo11$p2.lead) === null || _vm$milestoneInfo11$p3 === void 0 ? void 0 : (_vm$milestoneInfo11$p4 = _vm$milestoneInfo11$p3.data) === null || _vm$milestoneInfo11$p4 === void 0 ? void 0 : _vm$milestoneInfo11$p4.mobile) + " ")])]), _c('b-col', {
    staticClass: "p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end",
    attrs: {
      "xl": "6",
      "cols": "12"
    }
  }, [_c('div', [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("Payment Details:")]), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Total Due:")]), _c('td', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s((_vm$milestoneInfo12 = _vm.milestoneInfo) === null || _vm$milestoneInfo12 === void 0 ? void 0 : _vm$milestoneInfo12.grand_amount))])])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Bank Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo = _vm.accountInfo) === null || _vm$accountInfo === void 0 ? void 0 : _vm$accountInfo.bank_name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Account Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo2 = _vm.accountInfo) === null || _vm$accountInfo2 === void 0 ? void 0 : _vm$accountInfo2.name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Account Number:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo3 = _vm.accountInfo) === null || _vm$accountInfo3 === void 0 ? void 0 : _vm$accountInfo3.account_number))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Routing Number:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo4 = _vm.accountInfo) === null || _vm$accountInfo4 === void 0 ? void 0 : _vm$accountInfo4.routing_number))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Country:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo5 = _vm.accountInfo) === null || _vm$accountInfo5 === void 0 ? void 0 : (_vm$accountInfo5$coun = _vm$accountInfo5.country) === null || _vm$accountInfo5$coun === void 0 ? void 0 : (_vm$accountInfo5$coun2 = _vm$accountInfo5$coun.data) === null || _vm$accountInfo5$coun2 === void 0 ? void 0 : _vm$accountInfo5$coun2.name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("IBAN:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo6 = _vm.accountInfo) !== null && _vm$accountInfo6 !== void 0 && _vm$accountInfo6.iban_number ? (_vm$accountInfo7 = _vm.accountInfo) === null || _vm$accountInfo7 === void 0 ? void 0 : _vm$accountInfo7.iban_number : "N/A") + " ")])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("SWIFT code:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo8 = _vm.accountInfo) !== null && _vm$accountInfo8 !== void 0 && _vm$accountInfo8.swift_code ? (_vm$accountInfo9 = _vm.accountInfo) === null || _vm$accountInfo9 === void 0 ? void 0 : _vm$accountInfo9.swift_code : "N/A") + " ")])])])])])])], 1)], 1), _c('b-table-lite', {
    attrs: {
      "responsive": "",
      "items": _vm.invoiceDescription,
      "fields": ['miltestoneTitle', 'type', 'amount', 'vat', 'tax']
    },
    scopedSlots: _vm._u([{
      key: "cell(miltestoneTitle)",
      fn: function fn(data) {
        return [_c('b-card-text', {
          staticClass: "font-weight-bold mb-25"
        }, [_vm._v(" " + _vm._s(data.item.miltestoneTitle) + " ")])];
      }
    }, {
      key: "cell(amount)",
      fn: function fn(data) {
        var _vm$milestoneInfo13;
        return [_c('b-card-text', {
          staticClass: "font-weight-bold mb-25"
        }, [_vm._v(" " + _vm._s("".concat((_vm$milestoneInfo13 = _vm.milestoneInfo) === null || _vm$milestoneInfo13 === void 0 ? void 0 : _vm$milestoneInfo13.currency, " ").concat(data.item.amount)) + " ")])];
      }
    }])
  }), _c('b-card-body', {
    staticClass: "invoice-padding pb-0"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-md-0 mt-3",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }), _c('b-col', {
    staticClass: "mt-md-6 d-flex justify-content-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "invoice-total-wrapper"
  }, [_c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Subtotal:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo14 = _vm.milestoneInfo) === null || _vm$milestoneInfo14 === void 0 ? void 0 : _vm$milestoneInfo14.total_amount) + " ")])]), _c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("VAT:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo15 = _vm.milestoneInfo) === null || _vm$milestoneInfo15 === void 0 ? void 0 : _vm$milestoneInfo15.total_vat_amount) + " ")])]), _c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("TAX:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo16 = _vm.milestoneInfo) === null || _vm$milestoneInfo16 === void 0 ? void 0 : _vm$milestoneInfo16.total_tax_amount) + " ")])]), _c('hr', {
    staticClass: "my-50"
  }), _c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Grand Total:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s((_vm$milestoneInfo17 = _vm.milestoneInfo) === null || _vm$milestoneInfo17 === void 0 ? void 0 : _vm$milestoneInfo17.grand_amount) + " ")])])])])], 1)], 1), _c('hr', {
    staticClass: "invoice-spacing"
  }), _c('b-card-body', {
    staticClass: "invoice-padding pt-0"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Note: ")]), _c('span', [_vm._v("It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!")])])], 1)], 1), _c('b-col', {
    staticClass: "invoice-actions",
    attrs: {
      "cols": "12",
      "md": "4",
      "xl": "3"
    }
  }, [_c('b-card', [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(186, 191, 199, 0.15)',
      expression: "'rgba(186, 191, 199, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75",
    attrs: {
      "variant": "outline-secondary",
      "block": ""
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_vm._v(" Print ")]), _vm.$permissionAbility(_vm.INVOICE_PAYMENT_ACCESS, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-invoice-add-payment",
      modifiers: {
        "sidebar-invoice-add-payment": true
      }
    }, {
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75",
    attrs: {
      "variant": "success",
      "block": "",
      "disabled": ((_vm$milestoneInfo18 = _vm.milestoneInfo) === null || _vm$milestoneInfo18 === void 0 ? void 0 : _vm$milestoneInfo18.status) == 'due' ? false : true
    }
  }, [_vm._v(" Collect Payment ")])] : _vm._e()], 2)], 1)], 1), _c('div', {
    staticStyle: {
      "display": "none",
      "flex-direction": "column",
      "width": "100%"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 100%",
      "max-width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #e0e0e0",
      "border-radius": "5px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "0"
    }
  }, [_c('div', [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('logo')], 1), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.officeAddress))]), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(this.officeEmail))]), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(this.officeMobile))])]), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-right": "20px"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(" Invoice "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("# " + _vm._s((_vm$milestoneInfo19 = _vm.milestoneInfo) === null || _vm$milestoneInfo19 === void 0 ? void 0 : _vm$milestoneInfo19.invoice_no))]), ((_vm$milestoneInfo20 = _vm.milestoneInfo) === null || _vm$milestoneInfo20 === void 0 ? void 0 : _vm$milestoneInfo20.status) == 'paid' ? _c('span', {
    staticStyle: {
      "background-color": "rgba(40, 199, 111, 0.12)",
      "color": "#008000",
      "padding": "5px",
      "border-radius": "5px",
      "display": "inline-block"
    }
  }, [_vm._v("Paid")]) : ((_vm$milestoneInfo21 = _vm.milestoneInfo) === null || _vm$milestoneInfo21 === void 0 ? void 0 : _vm$milestoneInfo21.status) == 'due' ? _c('span', {
    staticStyle: {
      "background-color": "rgba(234, 84, 85, 0.12)",
      "color": "#ff0000",
      "padding": "5px",
      "border-radius": "5px",
      "display": "inline-block"
    }
  }, [_vm._v("Due")]) : ((_vm$milestoneInfo22 = _vm.milestoneInfo) === null || _vm$milestoneInfo22 === void 0 ? void 0 : _vm$milestoneInfo22.status) == 'forward' ? _c('span', {
    staticStyle: {
      "background-color": "#f0ad4e",
      "color": "#fff",
      "padding": "5px",
      "border-radius": "5px",
      "display": "inline-block"
    }
  }, [_vm._v("All Forwarded")]) : _vm._e()]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(" Date Issued: "), _c('b', [_vm._v(_vm._s(_vm.formatDeadline((_vm$milestoneInfo23 = _vm.milestoneInfo) === null || _vm$milestoneInfo23 === void 0 ? void 0 : _vm$milestoneInfo23.invoice_created_date)))])])]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(" Due Date: "), _c('b', [_vm._v(_vm._s(_vm.formatDeadline((_vm$milestoneInfo24 = _vm.milestoneInfo) === null || _vm$milestoneInfo24 === void 0 ? void 0 : _vm$milestoneInfo24.date)))])])])])])]), _c('hr', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _c('div', {
    staticStyle: {
      "padding": "20px",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "0"
    }
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Invoice To:")]), _c('h6', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo25 = _vm.milestoneInfo) === null || _vm$milestoneInfo25 === void 0 ? void 0 : (_vm$milestoneInfo25$p = _vm$milestoneInfo25.project) === null || _vm$milestoneInfo25$p === void 0 ? void 0 : (_vm$milestoneInfo25$p2 = _vm$milestoneInfo25$p.data) === null || _vm$milestoneInfo25$p2 === void 0 ? void 0 : (_vm$milestoneInfo25$p3 = _vm$milestoneInfo25$p2.lead) === null || _vm$milestoneInfo25$p3 === void 0 ? void 0 : (_vm$milestoneInfo25$p4 = _vm$milestoneInfo25$p3.data) === null || _vm$milestoneInfo25$p4 === void 0 ? void 0 : _vm$milestoneInfo25$p4.key_contact_person))]), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo26 = _vm.milestoneInfo) === null || _vm$milestoneInfo26 === void 0 ? void 0 : (_vm$milestoneInfo26$p = _vm$milestoneInfo26.project) === null || _vm$milestoneInfo26$p === void 0 ? void 0 : (_vm$milestoneInfo26$p2 = _vm$milestoneInfo26$p.data) === null || _vm$milestoneInfo26$p2 === void 0 ? void 0 : (_vm$milestoneInfo26$p3 = _vm$milestoneInfo26$p2.lead) === null || _vm$milestoneInfo26$p3 === void 0 ? void 0 : (_vm$milestoneInfo26$p4 = _vm$milestoneInfo26$p3.data) === null || _vm$milestoneInfo26$p4 === void 0 ? void 0 : _vm$milestoneInfo26$p4.company_name))]), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Address: " + _vm._s((_vm$milestoneInfo27 = _vm.milestoneInfo) === null || _vm$milestoneInfo27 === void 0 ? void 0 : (_vm$milestoneInfo27$p = _vm$milestoneInfo27.project) === null || _vm$milestoneInfo27$p === void 0 ? void 0 : (_vm$milestoneInfo27$p2 = _vm$milestoneInfo27$p.data) === null || _vm$milestoneInfo27$p2 === void 0 ? void 0 : (_vm$milestoneInfo27$p3 = _vm$milestoneInfo27$p2.lead) === null || _vm$milestoneInfo27$p3 === void 0 ? void 0 : (_vm$milestoneInfo27$p4 = _vm$milestoneInfo27$p3.data) === null || _vm$milestoneInfo27$p4 === void 0 ? void 0 : _vm$milestoneInfo27$p4.address))]), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Email: " + _vm._s((_vm$milestoneInfo28 = _vm.milestoneInfo) === null || _vm$milestoneInfo28 === void 0 ? void 0 : (_vm$milestoneInfo28$p = _vm$milestoneInfo28.project) === null || _vm$milestoneInfo28$p === void 0 ? void 0 : (_vm$milestoneInfo28$p2 = _vm$milestoneInfo28$p.data) === null || _vm$milestoneInfo28$p2 === void 0 ? void 0 : (_vm$milestoneInfo28$p3 = _vm$milestoneInfo28$p2.lead) === null || _vm$milestoneInfo28$p3 === void 0 ? void 0 : (_vm$milestoneInfo28$p4 = _vm$milestoneInfo28$p3.data) === null || _vm$milestoneInfo28$p4 === void 0 ? void 0 : _vm$milestoneInfo28$p4.email))]), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Mobile: " + _vm._s((_vm$milestoneInfo29 = _vm.milestoneInfo) === null || _vm$milestoneInfo29 === void 0 ? void 0 : (_vm$milestoneInfo29$p = _vm$milestoneInfo29.project) === null || _vm$milestoneInfo29$p === void 0 ? void 0 : (_vm$milestoneInfo29$p2 = _vm$milestoneInfo29$p.data) === null || _vm$milestoneInfo29$p2 === void 0 ? void 0 : (_vm$milestoneInfo29$p3 = _vm$milestoneInfo29$p2.lead) === null || _vm$milestoneInfo29$p3 === void 0 ? void 0 : (_vm$milestoneInfo29$p4 = _vm$milestoneInfo29$p3.data) === null || _vm$milestoneInfo29$p4 === void 0 ? void 0 : _vm$milestoneInfo29$p4.mobile))])]), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-right": "20px"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Payment Details:")]), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Total Due:")]), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo30 = _vm.milestoneInfo) === null || _vm$milestoneInfo30 === void 0 ? void 0 : _vm$milestoneInfo30.grand_amount))])])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Bank Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo10 = _vm.accountInfo) === null || _vm$accountInfo10 === void 0 ? void 0 : _vm$accountInfo10.bank_name))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Account Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo11 = _vm.accountInfo) === null || _vm$accountInfo11 === void 0 ? void 0 : _vm$accountInfo11.name))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Account Number:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo12 = _vm.accountInfo) === null || _vm$accountInfo12 === void 0 ? void 0 : _vm$accountInfo12.account_number))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Routing Number:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo13 = _vm.accountInfo) === null || _vm$accountInfo13 === void 0 ? void 0 : _vm$accountInfo13.routing_number))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Country:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo14 = _vm.accountInfo) === null || _vm$accountInfo14 === void 0 ? void 0 : (_vm$accountInfo14$cou = _vm$accountInfo14.country) === null || _vm$accountInfo14$cou === void 0 ? void 0 : (_vm$accountInfo14$cou2 = _vm$accountInfo14$cou.data) === null || _vm$accountInfo14$cou2 === void 0 ? void 0 : _vm$accountInfo14$cou2.name))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("IBAN:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo15 = _vm.accountInfo) !== null && _vm$accountInfo15 !== void 0 && _vm$accountInfo15.iban_number ? (_vm$accountInfo16 = _vm.accountInfo) === null || _vm$accountInfo16 === void 0 ? void 0 : _vm$accountInfo16.iban_number : "N/A"))])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("SWIFT code:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo17 = _vm.accountInfo) !== null && _vm$accountInfo17 !== void 0 && _vm$accountInfo17.swift_code ? (_vm$accountInfo18 = _vm.accountInfo) === null || _vm$accountInfo18 === void 0 ? void 0 : _vm$accountInfo18.swift_code : "N/A"))])])])])])])]), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.invoiceDescription, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "padding": "10px",
        "border-bottom": "1px solid #e0e0e0"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.miltestoneTitle))])]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border-bottom": "1px solid #e0e0e0"
      }
    }, [_vm._v(" " + _vm._s(item.type) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border-bottom": "1px solid #e0e0e0",
        "text-align": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.milestoneInfo.currency) + " " + _vm._s(item.amount))])]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border-bottom": "1px solid #e0e0e0",
        "text-align": "right"
      }
    }, [_vm._v(" " + _vm._s(item.vat) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border-bottom": "1px solid #e0e0e0",
        "text-align": "right"
      }
    }, [_vm._v(" " + _vm._s(item.tax) + " ")])]);
  }), 0)]), _c('div', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "flex-direction": "row"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 50%",
      "max-width": "50%",
      "margin-top": "20px"
    }
  }), _c('div', {
    staticStyle: {
      "flex": "0 0 50%",
      "max-width": "50%",
      "margin-top": "20px",
      "display": "flex",
      "justify-content": "flex-end",
      "padding-right": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Subtotal:")]), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo31 = _vm.milestoneInfo) === null || _vm$milestoneInfo31 === void 0 ? void 0 : _vm$milestoneInfo31.total_amount))])])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("VAT:")]), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo32 = _vm.milestoneInfo) === null || _vm$milestoneInfo32 === void 0 ? void 0 : _vm$milestoneInfo32.total_vat_amount))])])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("TAX:")]), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo33 = _vm.milestoneInfo) === null || _vm$milestoneInfo33 === void 0 ? void 0 : _vm$milestoneInfo33.total_tax_amount))])])]), _vm._m(1), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Grand Total:")]), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s((_vm$milestoneInfo34 = _vm.milestoneInfo) === null || _vm$milestoneInfo34 === void 0 ? void 0 : _vm$milestoneInfo34.grand_amount))])])])])])])])])]), _c('hr', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._m(2)])])]), _c('invoice-sidebar-send-invoice'), _vm.milestoneInfo ? [_c('invoice-sidebar-add-payment', {
    attrs: {
      "milestoneInfo": _vm.milestoneInfo
    },
    on: {
      "loadMilestoneInfo": _vm.updateMilestoneInfo
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "10px",
      "border-bottom": "2px solid #e0e0e0"
    }
  }, [_vm._v("Milestone Title")]), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "10px",
      "border-bottom": "2px solid #e0e0e0"
    }
  }, [_vm._v("Type")]), _c('th', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px",
      "border-bottom": "2px solid #e0e0e0"
    }
  }, [_vm._v("Amount")]), _c('th', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px",
      "border-bottom": "2px solid #e0e0e0"
    }
  }, [_vm._v("VAT")]), _c('th', {
    staticStyle: {
      "text-align": "right",
      "padding": "10px",
      "border-bottom": "2px solid #e0e0e0"
    }
  }, [_vm._v("Tax")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('hr', {
    staticStyle: {
      "margin": "10px 0"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "padding": "20px",
      "padding-top": "0"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Note: ")]), _c('span', [_vm._v("It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!")])])]);
}]

export { render, staticRenderFns }